import { render, staticRenderFns } from "./RejectShipmentModal.vue?vue&type=template&id=60a9aafc&scoped=true"
import script from "./RejectShipmentModal.vue?vue&type=script&lang=js"
export * from "./RejectShipmentModal.vue?vue&type=script&lang=js"
import style0 from "./RejectShipmentModal.vue?vue&type=style&index=0&id=60a9aafc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60a9aafc",
  null
  
)

export default component.exports